<template>
  <section class="login">
    <h1>Welcome</h1>
    <form @submit.prevent="onSubmit" class="login__form">
      <p class="login__error-message" v-if="authenticationFailed">
        <strong id="login-error-title">Login failed.</strong>
        <br />
        <span id="login-error-message">{{ errorMessage }}</span>
      </p>
      <fieldset class="login__email-fieldset">
        <label for="login__email-input" class="login__email-label">Login</label>
        <input
          v-model="username"
          id="login-email-input"
          name="login__email-input"
          type="text"
          class="login__email-input"
        />
      </fieldset>
      <fieldset class="login__password-fieldset">
        <label for="login__password-input" class="login__password-label">Password</label>
        <input
          v-model="password"
          id="login-password-input"
          name="login__password-input"
          type="password"
          class="login__password-input"
        />
      </fieldset>
      <footer class="login__footer">
        <input type="submit" id="login-submit" value="Login" v-if="!authenticating" class="login__submit" />
        <i v-if="authenticating" class="login__loading-spinner">
          <font-awesome-icon class="fa-spin fa-3x fa-fw" :icon="['fas', 'cog']" />
        </i>
        <a :href="resetPasswordUrl" class="login__forgot-password-link">Forgot your password?</a>
      </footer>
    </form>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'Login',

  components: {
    FontAwesomeIcon,
  },

  data() {
    return {
      username: '',
      password: '',
      authenticating: false,
      authenticationFailed: false,
      resetPasswordUrl: `${process.env.RESET_PASSWORD_URL}`,
      error: null,
    };
  },

  beforeMount() {
    this.logout();
  },

  computed: {
    errorMessage() {
      return (
        this.error || 'Either your email or password were incorrect, or you do not have access to the Command Center.'
      );
    },
  },

  methods: {
    ...mapActions({
      logout: 'LOGOUT',
    }),

    async onSubmit() {
      this.error = null;
      this.authenticationFailed = false;
      this.authenticating = true;

      try {
        await this.$store.dispatch('USER_AUTHENTICATION', {
          username: this.username,
          password: this.password,
        });

        await this.$router.push('/learners', () => {
          this.authenticating = false;
        });
      } catch (e) {
        if (e.non_field_errors) {
          const [error] = e.non_field_errors;

          this.error = error;
        }

        Rollbar.info('Login failed');
        this.authenticationFailed = true;
        this.authenticating = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import '~styles/tools/variables';

.login {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
}

.login__form {
  max-width: 400px;
  width: 100%;
  border-radius: 5px;
  background-color: $default-lighter-grey;
  padding: 20px;
}

.login__footer {
  margin-top: 25px;
  display: flex;
  align-items: center;
}

.login__submit {
  padding: 10px;
  border: 1px solid #fff;
  color: white;
  text-transform: uppercase;
  letter-spacing: 2px;
  cursor: pointer;
}

.login__submit:hover {
  box-shadow: inset 0 3px 2px rgba(0, 0, 0, 0.3);
}

.login__forgot-password-link {
  margin: auto 0 auto auto;
}

.login__email-input,
.login__password-input {
  border-radius: 2px;
  background-color: #fff;
  width: 100%;
  margin-top: 10px;
  height: 30px;
}

.login__password-fieldset {
  margin-top: 20px;
}

.login__email-fieldset,
.login__password-fieldset {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 0;
}

.login__email-label,
.login__password-label {
  text-align: left;
  font-weight: bold;
  text-transform: uppercase;
}

.login__error-message {
  background: $default-red;
  color: white;
  padding: 1rem;
}
</style>
